module.exports = __webpack_public_path__ + "img/public/AdminIcons/whistListGoIcon.svg?ae40f57e";